export default __webpack_public_path__ + "static/media/balance_setting_8.b0baf2aa.png";